import { render } from "./PointBulkGrantHistory.vue?vue&type=template&id=d13b3df6&scoped=true&ts=true"
import script from "./PointBulkGrantHistory.vue?vue&type=script&lang=ts"
export * from "./PointBulkGrantHistory.vue?vue&type=script&lang=ts"

import "./PointBulkGrantHistory.vue?vue&type=style&index=0&id=d13b3df6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hori_taiki\\Desktop\\小野写真館\\環境構築\\point-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d13b3df6"]])

export default __exports__